import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconPlayButton = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 512 512",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm115.7 272l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z"
	})
});
export default SvgIconPlayButton;
